import { call, put } from 'redux-saga/effects';
import GetWithdrawalActions from '../redux/GetWithdrawalRedux';
import { api } from './api';


export function* getwithdrawalsagas(action: any): Generator<any, void, any> {
  const { withdrawal_id } = action;
  const response = yield call(api.getWithdrawal, withdrawal_id);

  // success?
  if (response.ok) {
    // You might need to change the response here - do this with a 'transform',
    // located in ../Transforms/. Otherwise, just pass the data back from the api.
    yield put(GetWithdrawalActions.getWithdrawalSuccess(response.data));
  } else {
    yield put(GetWithdrawalActions.getWithdrawalFailure());
  }
}